<template>
  <div class="size-20 rounded-full shadow-xl shadow-blue-950/20 flex cursor-pointer justify-center items-center border border-white/80 bg-white/10 group-hover:bg-white/30 group-hover:border-white ">
    <UIcon name="bx:play" class="text-white/80 group-hover:text-white text-5xl" />
  </div>
</template>
